module.exports = __webpack_public_path__ + "img/app-store-badge.2a41a36f.png";